export default "__VITE_ASSET__zan_zU7w__"